export function isTextSegment(
  item?: ProposalSegment | Partial<ProposalSegment & Record<'id', string>>,
): item is TextSegment {
  return item?.type === 'text';
}
